import React from 'react';
import {
  FaBookOpen,
  FaChartLine,
  FaCheck,
  FaClipboardCheck,
  FaGift,
  FaMicrophone
} from 'react-icons/fa';

const ICONS = {
  chart: FaChartLine,
  clipboard: FaClipboardCheck,
  check: FaCheck,
  mic: FaMicrophone,
  book: FaBookOpen,
  gift: FaGift
};

const SoftIcon = ({ name = 'check', size = 'md' }) => {
  const Icon = ICONS[name] || FaCheck;
  return (
    <span className={`soft-icon soft-icon--${size}`} aria-hidden="true">
      <Icon />
    </span>
  );
};

export default SoftIcon;
